import { Account } from 'model/IChat';
import pluralize from 'pluralize';
import React from 'react';
import RoundedAvatar from 'reusable-components/avatars/RoundedAvatar';

const CSS = require('./BookBlockLocals.module.scss');

interface BookBlockLocalsProps {
  locals: Partial<Account>[];
}

function BookBlockLocals({ locals }: BookBlockLocalsProps) {
  const nrOfLocals = locals?.length;
  const localsToShow = locals.slice(0, Math.min(2, locals.length));
  return (
    <div className={CSS.BookBlockLocals}>
      <figure className={CSS.HostImages} data-multiple={nrOfLocals > 1}>
        {localsToShow.map((local, index) => (
          <RoundedAvatar
            key={`image-${index}`}
            image={local?.photo}
            size={48}
            height={64}
            thumb
            alt={`image of ${local?.firstName}, ${local?.personal_title}`}
            color={index === 1 ? 'pink-100' : 'pink'}
            className={CSS.Avatar}
            borderSize={1}
          />
        ))}
      </figure>
      <p className={CSS.Text}>
        {nrOfLocals > 0 && <strong className={CSS.TextLabel}>Hosted by</strong>}
        {nrOfLocals > 1 && (
          <>
            <strong
              className={CSS.NrOfLocals}
              data-test-id="BookBlockLocalName"
            >
              {localsToShow[0]?.firstName}
            </strong>{' '}
            and <strong className={CSS.NrOfLocals}>{nrOfLocals - 1}</strong>{' '}
            other {pluralize('local', nrOfLocals - 1)}
          </>
        )}
        {nrOfLocals === 1 && (
          <>
            <span className={CSS.LocalName} data-test-id="BookBlockLocalName">
              {localsToShow[0].firstName}
            </span>
            <span className={CSS.PersonalTitle}>
              {localsToShow[0].personal_title}
            </span>
          </>
        )}
      </p>
    </div>
  );
}

export default BookBlockLocals;
